import { createHOC } from 'vue-hoc';

import userManagement from '~lib/common/providers/userManagement';
import parseGroupMetadata from '~lib/common/utils/parseGroupMetadata';

import NotificationTargets from './NotificationTargets';

const options = {
  name: 'NotificationTargetsContainer',
  data() {
    return {
      state: {
        loading: false,        
        allOrgs: [],
        users: [],
        error: null,
      },
    };
  },
  async created() {
    this.state.allOrgs = await this.getAllOrgs();
  },
  methods: {    
    async getAllOrgs() {
      try {
        this.state.loading = true;
        let orgs = (await userManagement.get("/extension/groups")).data.groups
          .map(group => ({
            ...group,
            metadata: parseGroupMetadata(group)
          }))
          .filter(group => !group.metadata.parent);
        return orgs;
      } catch (e) {
        this.state.error = e;
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const renderWith = {
  props: {
    orgs() {
      return this.state.allOrgs;
    },
    users() {
      return this.state.users;
    }
  },
  listeners: {    
    async filterUsers(term) {
      if (!term || term.length < 3) {
        this.state.users = [];
        return;
      }
      try {
        this.state.error = null;
        this.state.loading = true;
        const response = await userManagement.get('/users', {
          // Auth0 wildcard searches must use a term with at least 3 characters
          q: `*${term}*`,
        });
        this.state.users = response.data;
      } catch (e) {
        console.error(e);
        this.state.error = e;
      } finally {
        this.state.loading = false;
      }
    },
  },
};

export default createHOC(NotificationTargets, options, renderWith);